module.exports = __webpack_public_path__ + "img/instore.51c3245f.png";